import {
  createTrackingEventData,
  trackEventWrapper,
} from './newRelicTrackingUtils';

// Customer feedback request events
const CUSTOMER_FEEDBACK_SUBTYPE = 'orders-ui-customer-feedback-request';

// Design feedback request events
const DESIGN_FEEDBACK_BANNER_SUBTYPE = 'design-banner';
const DESIGN_FEEDBACK_REQUEST_BANNER_PRESENTED = `${CUSTOMER_FEEDBACK_SUBTYPE}-${DESIGN_FEEDBACK_BANNER_SUBTYPE}-presented`;
const DESIGN_FEEDBACK_REQUEST_BANNER_REDIRECT_LINK_CLICKED = `${CUSTOMER_FEEDBACK_SUBTYPE}-${DESIGN_FEEDBACK_BANNER_SUBTYPE}-redirect-link-clicked`;

/**
 * A shopper was presented the design feedback request banner
 * @param {string} groupId - The feedback group ID.
 * @param {object} additionalData - Additional data to include in the tracking event.
 * @returns {void} - calls trackEventWrapper
 */
export const trackDesignFeedbackBannerPresented = (
  groupId: string = '',
  additionalData: object = {}
) => {
  const trackingEventAdditionalData = {
    ...additionalData,
    groupId,
  };
  const eventData = createTrackingEventData(
    DESIGN_FEEDBACK_REQUEST_BANNER_PRESENTED,
    trackingEventAdditionalData
  );
  trackEventWrapper(eventData);
};

/**
 * A shopper clicked the link in the design feedback request banner.
 * @param {string} groupId - The feedback group ID, which will be added to additional data.
 * @param {object} additionalData - Additional data to include in the tracking event.
 * @returns {void} - calls trackEventWrapper
 */
export const trackDesignFeedbackBannerRedirectLinkClicked = (
  groupId: string = '',
  additionalData: object = {}
) => {
  const trackingEventAdditionalData = {
    ...additionalData,
    groupId,
  };
  const eventData = createTrackingEventData(
    DESIGN_FEEDBACK_REQUEST_BANNER_REDIRECT_LINK_CLICKED,
    trackingEventAdditionalData
  );
  trackEventWrapper(eventData);
};
